// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OiUx_","rootMobile":"styles_rootMobile__13zCZ"};